<template>
  <div class="wheelAssembly" @click="roundTheTableBelow = ''">
    <div class="close">
      <div class="operation">
        <div @click="closingWheel"><span class="iconfont icon-guanbi"></span></div>
      </div>
    </div>

    <div class="state">
      <i><i class="iconfont icon-wushuju"></i> 手指按住卡片即可拖动卡片调整位置</i> <span v-for="item in 4" :key="item">{{
        modifiableState[item - 1].state }}</span>
    </div>
    <div class="roundList" ref="wheelAssemblyRef">
      <template v-if="wheelData.length">
        <div class="roundList_item" ref="roundListItemRef" v-for="(item, index) in wheelData" :key="index">
          <span class="wheel_title">{{ item.wheelName }}</span>
          <div class="employee" ref="employeeRef">
            <!-- <div class="employee_item" @click.stop="" v-bag="staff.state" v-for="(staff, staffIndex) in item.employeeList" :key="staffIndex"
                           @mousedown.prevent.stop="pressEvent($event,`${index}-${staffIndex}`)" @touchstart.prevent.stop="pressEvent($event,`${index}-${staffIndex}`)"> -->
            <div class="employee_item" v-bag="staff.state" v-for="(staff, staffIndex) in item.employeeList"
              :key="staff.id" @touchstart.prevent.stop="pressEvent($event, `${index}-${staffIndex}`)"
              @mousedown.prevent.stop="pressEvent($event, `${index}-${staffIndex}`)" @click.stop="">
              <span>{{ staff.employeeNo }}</span> <span>{{ staff.employeeName }}</span> <span>{{ staff.deltaT ||
                "00:00:00" }}</span>
              <div class="employee_top">
                <span class="head"> <svg-icon style="font-size: 25px; color: #303133" class="default_head"
                    icon-class="default_head"></svg-icon> </span>
                <span class="icon">
                  <span>{{ getState(staff.state) }}</span> <span class="iconfont icon-xiala"></span>
                </span>
              </div>
              <!--    弹出层      -->
              <div class="popups" v-show="roundTheTableBelow === `${index}-${staffIndex}`" @mousedown.stop=""
                @touchstart.stop="">

                <div class="popups_item" v-for="(item, $index) in modifiableState" :key="$index"
                  @click.stop="updateStatus(item.value, index, staffIndex)">
                  <span>{{ item.state }}</span>
                </div>
              </div>
            </div>

            <div class="employee_add" ref="employeeAddRef" @click="employeePopUpLayer(index)"><span
                class="iconfont icon-tianjia"></span></div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="noData">
          <div class="onData_box" @click="goToSettings">
            <span class="iconfont icon-wushuju"></span> <span>还未设置轮牌,</span><span @click="
              $router.push({
                name: 'Memberstoresettings',
                params: {
                  type: 'second',
                },
              })
              " style="color: #1E90FF;text-decoration: underline;cursor: pointer;user-select: none">去设置</span>
          </div>
        </div>
      </template>
    </div>

    <!--   员工筛选   -->
    <div class="box_show" v-show="employeeScreeningDialogBox" @click="employeeScreeningDialogBox = false">
      <div class="screeningStaff" @click.stop="">
        <div class="header"><span>选择员工</span> <span class="iconfont icon-guanbi"
            @click="employeeScreeningDialogBox = false"></span></div>
        <div class="screenItem">
          <div v-for="item in employeeDataList" :key="item.id">
            <template v-if="item.wheelEmployeeLists.length">
              <span>{{ item.postName }}</span>
              <div>
                <div v-for="subItem in item.wheelEmployeeLists" :key="subItem.id" @click.stop="addStaff(subItem)">
                  <i :class="{ active: subItem.sign }"></i> <i>{{ `${subItem.employeeNo} ${subItem.employeeName}` }}</i>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="confirmAddition"><span @click="employeeScreeningDialogBox = false">取 消</span> <span
            :class="{ active: addedNumber }" @click="confirmAddition">添 加</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "wheel",
  data() {
    return {
      // 轮牌设置列表
      wheelData: [],
      // 状态
      modifiableState: [
        {
          state: "轮牌",
          value: 1,
        },
        {
          state: "待客",
          value: 2,
        },
        {
          state: "点客",
          value: 3,
        },
        {
          state: "盖牌",
          value: 4,
        },
        {
          state: "下牌",
          value: 5,
        },
      ],
      // 轮牌下标
      roundTheTableBelow: "",
      // 替换下标
      alternateIndex: "",
      // 鼠标数据
      mouseData: {
        parentDom: null, // 父级节点
        movingDom: null, // 子级节点
        rightCriticalValue: 0, // 右侧临界值
        mousePageX: "",
        currentX: "", // 当前子集元素左侧距离距离
        movingData: null, // 数据缓存
        parentDataBelowTable: 0, // 父级数据下表
        subLevelDataBelowTable: 0, // 子级数据下表
        mouseDownOnTheTimestamp: "", // 鼠标按下时间戳
        mouseLiftTimeStamp: "", // 鼠标抬起时间戳
      },
      employeeDataList: [], // 员工数据列表
      timer: null, // 移动调整位置计时器
      employeeStatusTimer: null, // 状态计时器
      employeeScreeningDialogBox: false, // 员工筛选对话框
      enableMobileMode: false, // 开启移动模式
      addDataSubscript: "",
    };
  },
  directives: {
    bag(el, binding) {
      const { value } = binding;
      let bag = null;
      switch (value) {
        case 1:
          bag = "#CD4754";
          break;
        case 2:
          bag = "#5DAE72";
          break;
        case 3:
          bag = "#E59B37";
          break;
        case 4:
          bag = "#555555";
          break;
        default:
      }
      el.style.backgroundColor = bag;
    },
    update(el, binding) { // 更新卡片样式
      const { value } = binding;
      let bag = null;
      switch (value) {
        case 1:
          bag = "#CD4754";
          break;
        case 2:
          bag = "#5DAE72";
          break;
        case 3:
          bag = "#E59B37";
          break;
        case 4:
          bag = "#555555";
          break;
        default:
      }
      el.style.backgroundColor = bag;
    }
  },
  computed: {
    addedNumber() {
      let content = 0;
      this.employeeDataList.forEach((item) => {
        content += item.wheelEmployeeLists.reduce((previousValue, currentValue) => {
          if (currentValue.sign) return ++previousValue;
          else return previousValue;
        }, 0);
      });
      return content;
    },
  },
  created() {
    this.getWheelData(); // 获取班次数据列表
  },
  methods: {
    // 去设置
    goToSettings() { },
    // 更新状态
    updateStatus(state, index, staffIndex) {
      console.log("更新状态", index, staffIndex);
      let param = {
        id: this.wheelData[index].employeeList[staffIndex].id,
        wheelId: this.wheelData[index].id,
        state,
      };
      if (state === 5) {
        this.wheelData[index].employeeList.splice(staffIndex, 1);
      } else {
        let data = JSON.parse(JSON.stringify(this.wheelData[index].employeeList[staffIndex]));
        this.wheelData[index].employeeList.splice(staffIndex, 1);
        data.startDate = moment().format("YYYY-MM-DD HH:mm:ss");
        data.state = state;
        this.wheelData[index].employeeList.push(data);
      }
      this.API.store.updateStatus(param).then(async (res) => {
        this.$message.success("修改成功");
        this.roundTheTableBelow = "";
      });
    },
    // 确认添加员工
    confirmAddition() {
      let newEmployeeIds = [];
      this.employeeDataList.forEach((item) => {
        item.wheelEmployeeLists.forEach((subItem) => {
          if (subItem.sign) newEmployeeIds.push(subItem);
        });
      });
      let param = {
        wheelId: this.wheelData[this.addDataSubscript].id,
        employeeIds: newEmployeeIds.map((item) => item.id),
      };
      if (!param.employeeIds.length) return this.$message.warning("请先选择员工");
      this.API.store.increaseEffectiveStaff(param).then(async (res) => {
        await this.getWheelData(); // 刷新数据
        this.$message.success("添加成功");
        this.employeeScreeningDialogBox = false;
      });
    },
    // 添加员工
    addStaff(item) {
      item.sign = !item.sign;
    },
    // 关闭轮牌
    closingWheel() {
      this.$emit("handleClose");
      clearInterval(this.employeeStatusTimer);
    },
    // 刷新时间差
    refreshEvent() {
      clearInterval(this.employeeStatusTimer);
      this.employeeStatusTimer = setInterval(() => {
        this.wheelData.forEach((item) => {
          item.employeeList.forEach((subItem) => {
            subItem.deltaT = this.timeFormat(subItem.startDate);
          });
        });
      }, 1000);
    },
    // 计算时间差
    timeFormat(time) {
      let d1 = new Date(time);
      let d2 = new Date();
      let cha = Math.abs(d2.getTime() - d1.getTime());
      let days = parseInt(cha / (24 * 60 * 60 * 1000));
      let hours = parseInt((cha % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
      let mins = parseInt((cha % (60 * 60 * 1000)) / (60 * 1000));
      let s = parseInt((cha % (60 * 1000)) / 1000);

      if (days) {
        hours += 24 * days;
      }
      if (hours >= 72) return "72:00:00";

      return `${hours <= 9 ? "0" + hours : hours}:${mins <= 9 ? "0" + mins : mins}:${s <= 9 ? "0" + s : s}`;
    },
    getState(status) {
      let state = "";
      switch (status) {
        case 1:
          state = "轮牌";
          break;
        case 2:
          state = "待客";
          break;
        case 3:
          state = "点客";
          break;
        case 4:
          state = "盖牌";
          break;
        default:
      }
      return state;
    },
    // 获取轮牌数据
    async getWheelData() {
      return new Promise((resolve, reject) => {
        this.API.store.wheelPlateSetting().then((res) => {
          res.data.records.forEach((item) => {
            item.employeeList.forEach((item) => {
              item.offsetX = "";
              item.deltaT = "";
            });
          });
          this.refreshEvent(); // 刷新计时器
          this.wheelData = res.data.records;
          resolve();
        });
      });
    },
    // 员工弹出层
    employeePopUpLayer(index) {
      this.addDataSubscript = index;
      // 获取可选员工数据
      this.API.store.wheelEmployee(this.wheelData[this.addDataSubscript].id).then((res) => {
        let count = 0;
        count += res.data.reduce((previousValue, currentValue) => {
          if (currentValue.wheelEmployeeLists.length) return ++previousValue;
          else return previousValue;
        }, 0);
        if (!count) return this.$message.warning("该轮牌员工已全部添加");
        res.data.forEach((item) => {
          item.wheelEmployeeLists.forEach((subItem) => {
            subItem.sign = false;
          });
        });
        this.employeeScreeningDialogBox = true;
        this.employeeDataList = res.data;
      });
    },
    // 选择
    selectEmployees(staffIndex, index) {
      console.log("点击事件", staffIndex, index);
      // 点击事件需要清除一下样式
      let coordinate = `${index}-${staffIndex}`; // 计算坐标
      for (let i = 0; i < this.$refs.roundListItemRef.length; i++) {
        this.$refs.roundListItemRef[i].style.zIndex = 0;
        this.$refs.employeeRef[i].style.overflowX = "auto";
      }
      if (this.roundTheTableBelow === coordinate) {
        this.roundTheTableBelow = ""; // 取消选择
      } else {
        // 修复层级问题
        this.$refs.roundListItemRef[index].style.zIndex = 9999;
        this.$refs.employeeRef[index].style.overflowX = "unset";
        this.roundTheTableBelow = coordinate; // 存储所选顾客下表
      }

      console.log("存储后的数据", this.roundTheTableBelow);
    },
    // 鼠标按下事件
    pressEvent($event, index) {
      console.log("手指按下事件");
      this.mouseData.mouseDownOnTheTimestamp = new Date().getTime(); // 获取当前按下时间戳
      const parentTableBelow = index.split("-")[0] * 1;
      const subLevelBelowTable = index.split("-")[1] * 1;
      let pageX = $event.pageX || $event.changedTouches[0].pageX; // 设配移动端
      this.mouseData.parentDataBelowTable = parentTableBelow; // 父级元素下表
      this.mouseData.subLevelDataBelowTable = subLevelBelowTable; // 子元素下表
      this.mouseData.parentDom = this.$refs.employeeRef[parentTableBelow]; // 父级节点
      this.mouseData.movingDom = this.mouseData.parentDom.children[subLevelBelowTable]; // 子级节点
      this.mouseData.mousePageX = pageX - this.mouseData.movingDom.offsetLeft; // 鼠标按下的位置
      this.mouseData.currentX = this.mouseData.movingDom.offsetLeft; // 当前子集元素左侧距离距离
      this.mouseData.rightCriticalValue = this.$refs.employeeAddRef[parentTableBelow].offsetLeft; // 右边临界值
      // 存储所有节点的左侧距离左边的距离
      this.wheelData[parentTableBelow].employeeList.forEach((item, index) => {
        item.offsetX = this.mouseData.parentDom.children[index].offsetLeft; // 每个元素距离左侧的距离
      });

      this.$refs.wheelAssemblyRef.onmouseup = this.mouseLiftEvent;
      // this.$refs.wheelAssemblyRef.ontouchend = this.mouseLiftEvent;
      // PC端事件绑定
      this.$refs.wheelAssemblyRef.onmousemove = this.mouseMovementEvent;
      // 移动端事件绑定
      this.$refs.wheelAssemblyRef.ontouchmove = this.mouseMovementEvent;

      // 移动端一次性触摸结束监听
      const touchEndHandler = (e) => {
        this.mouseLiftEvent(e);
        document.removeEventListener('touchend', touchEndHandler);
        document.removeEventListener('touchcancel', touchEndHandler);
      };
      document.addEventListener('touchend', touchEndHandler);
      document.addEventListener('touchcancel', touchEndHandler);

      // 延迟绑定移动
      this.timer = setTimeout(() => {
        this.selectStyle(); // 选中样式
        this.timer = null;
      }, 500);
    },
    // 鼠标抬起事件
    async mouseLiftEvent() {
      this.mouseData.mouseLiftTimeStamp = new Date().getTime(); // 获取当前抬起时间戳
      const pressDuration = this.mouseData.mouseLiftTimeStamp - this.mouseData.mouseDownOnTheTimestamp;

      // 清除长按定时器
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      // 短按且未开启拖动模式，视为点击弹出框
      if (pressDuration < 500 && !this.enableMobileMode) {
        this.selectEmployees(this.mouseData.subLevelDataBelowTable, this.mouseData.parentDataBelowTable);
        // 清理全局事件
        this.$refs.wheelAssemblyRef.onmousemove = null;
        this.$refs.wheelAssemblyRef.onmouseup = null;
        this.$refs.wheelAssemblyRef.ontouchmove = null;
        return;
      }

      // 判断按下事件 与抬起事件是否小于30毫秒 如果小于则为点击事件
      if (this.mouseData.mouseLiftTimeStamp - this.mouseData.mouseDownOnTheTimestamp < 500) {
        clearTimeout(this.timer);
        this.mouseData.movingDom.style.position = "relative";
        this.mouseData.movingDom.style.left = "0px";
        this.mouseData.movingDom.style.zIndex = "2";
        this.mouseData.movingDom.style.boxShadow = "none";
        this.mouseData.movingDom.style.cursor = "pointer";
        this.selectEmployees(this.mouseData.subLevelDataBelowTable, this.mouseData.parentDataBelowTable);
        return;
      }
      this.$refs.wheelAssemblyRef.onmousemove = null; // 清除鼠标移动事件
      this.$refs.wheelAssemblyRef.onkeyup = null; // 清除鼠标抬起事件
      // 移动端事件解除
      this.$refs.wheelAssemblyRef.ontouchmove = null;
      this.$refs.wheelAssemblyRef.ontouchend = null;

      this.dataRearrangement() && (await this.storedDataStructure()); // 数据重排
      this.moveStyleClear(); // 清除移动样式
    },
    // 鼠标移动事件
    mouseMovementEvent($event) {
      if (!this.enableMobileMode) return;
      let pageX = $event.pageX || $event.changedTouches[0].pageX; // 设配移动端
      let eachMouseMove = pageX - this.mouseData.mousePageX;
      this.mouseData.movingDom.style.position = "absolute";
      // 临界值判断
      if (eachMouseMove <= 0) {
        eachMouseMove = 0;
      }
      if (eachMouseMove + 90 >= this.mouseData.rightCriticalValue) {
        eachMouseMove = this.mouseData.rightCriticalValue - 90;
      }
      // 计算占位元素
      this.computesPlaceholderElements(eachMouseMove);
      this.mouseData.movingDom.style.left = `${eachMouseMove}px`;
    },
    // 存储数据结构
    storedDataStructure() {
      return new Promise((resolve, reject) => {
        let param = this.wheelData[this.mouseData.parentDataBelowTable].employeeList.map((item) => {
          return {
            id: item.id,
          };
        });
        this.API.store.updateCardOrder(param).then((res) => {
          this.$message.success("调整成功");
        });
        resolve();
      });
    },
    // 计算占位元素
    computesPlaceholderElements(x) {
      let employeeList = this.wheelData[this.mouseData.parentDataBelowTable].employeeList;
      for (let i = 0; i < employeeList.length; i++) {
        if (x === 0) {
          console.log("等于第一");
          if (this.alternateIndex === "first") break;
          this.alternateIndex = "first";
        }
        let lastX = employeeList.length * 90 - 90; // 宽度 - 90自身宽度
        if (!employeeList[i] && x === lastX) {
          this.alternateIndex = "last";
        } else if (employeeList[i].offsetX < x && employeeList[i + 1].offsetX >= x) {
          if (this.alternateIndex === i) break;
          this.alternateIndex = i;
        }
      }
      // 预选样式
      this.preselectedStyle();
    },
    // 预选样式
    preselectedStyle() {
      let employeeList = this.$refs.employeeRef[this.mouseData.parentDataBelowTable].children;
      for (let i = 0; i < employeeList.length - 1; i++) {
        employeeList[i].style.border = null;
      }
      let dom1 = null;
      let dom2 = null;
      // 先清除一下所有样式效果
      if (this.alternateIndex === "first") dom1 = employeeList[0];
      else if (this.alternateIndex === "last") dom1 = employeeList[employeeList.length - 2];
      else {
        dom1 = employeeList[this.alternateIndex];
        dom2 = employeeList[this.alternateIndex + 1];
      }
      this.$nextTick(() => {
        dom1.style.border = "2px dotted #000";
        dom2 && (dom2.style.border = "2px dotted #000");
      });
    },
    // 数据重排
    dataRearrangement() {
      if (this.alternateIndex === "") return false;
      if (this.alternateIndex === "first") {
        this.alternateIndex = -1;
      }
      if (this.alternateIndex === "last") {
        this.alternateIndex = this.wheelData[this.mouseData.parentDataBelowTable].employeeList.length - 1;
      }
      this.dataExchange(this.wheelData[this.mouseData.parentDataBelowTable].employeeList, this.mouseData.subLevelDataBelowTable, Number(this.alternateIndex) + 1);
      this.alternateIndex = "";
      return true;
    },
    // 数据交换 dataList数据 index1要换的数据 index2被替换的数据
    dataExchange(dataList, index1, index2) {
      console.log(index1, index2);
      let data = dataList.splice(index1, 1)[0];
      dataList.splice(index2, 0, data);
    },
    // 符合条件
    dataProcessing(index) {
      let employeeList = this.wheelData[this.mouseData.parentDataBelowTable].employeeList;
      if (employeeList[index + 1 || 0].positionData) return;
      if (index === undefined) {
        console.log("首位调整");
      } else {
        console.log("调整下表", index);
        console.log("数据", employeeList);
      }
    },
    // 清除移动样式
    moveStyleClear() {
      this.mouseData.movingDom.style.position = "relative";
      this.mouseData.movingDom.style.left = "0px";
      this.mouseData.movingDom.style.zIndex = "2";
      this.mouseData.movingDom.style.boxShadow = "none";
      this.mouseData.movingDom.style.cursor = "pointer";
      this.enableMobileMode = false; // 关闭移动模式
      let employeeList = this.$refs.employeeRef[this.mouseData.parentDataBelowTable].children;
      for (let i = 0; i < employeeList.length - 1; i++) {
        employeeList[i].style.border = null;
      }
      // 数据裁剪
      try {
        if (this.wheelData[this.mouseData.parentDataBelowTable].employeeList[this.mouseData.subLevelDataBelowTable + 1].positionData) {
          this.wheelData[this.mouseData.parentDataBelowTable].employeeList.splice(this.mouseData.subLevelDataBelowTable + 1, 1);
        }
      } catch (e) { }
      // 恢复默认样式
      Object.assign(this.mouseData, {
        rightCriticalValue: 0, // 右侧临界值
        mousePageX: "",
        currentX: "", // 当前子集元素左侧距离距离
        movingData: null, // 数据缓存
        parentDataBelowTable: 0, // 父级数据下表
        subLevelDataBelowTable: 0, // 子级数据下表
        mouseDownOnTheTimestamp: "",
        mouseLiftTimeStamp: "",
      });
    },
    // 选中样式
    selectStyle() {
      this.enableMobileMode = true; // 开启移动模式
      this.roundTheTableBelow = ""; // 关闭样式选中
      this.mouseData.movingDom.style.zIndex = "20";
      this.mouseData.movingDom.style.boxShadow = "0 2px 8px 0 rgba(0, 0, 0, 0.6)";
      this.mouseData.movingDom.style.cursor = "grabbing";
    },
  },
};
</script>

<style scoped lang="scss">
.wheelAssembly {
  width: 100%;
  height: 100%;
  position: relative;

  .close {
    padding-left: 10px;
    height: 50px;
    box-sizing: border-box;
    box-shadow: 0 -2px 10px hsla(0, 0%, 73.3%, 0.4);
    border-bottom: 1px solid #d9d9d9;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .operation {
      display: flex;
      justify-content: flex-end;

      >div {
        width: 120px;
        height: 100%;
        border-left: 1px solid #d9d9d9;
        font-size: 0;
        line-height: 50px;
        text-align: center;
        user-select: none;

        &:first-child {
          background-color: rgba(255, 0, 0, 0.5);
          cursor: not-allowed;

          &.active {
            background-color: rgba(255, 0, 0, 0.9);
            cursor: pointer;
          }
        }

        span {
          color: #ffffff;
        }

        >span {
          font-size: 16px;
          margin-right: 5px;
          vertical-align: middle;
        }

        &:last-child {
          background-color: #595959;
          cursor: pointer;

          span {
            color: #ffffff;
            font-size: 22px;
          }
        }
      }
    }
  }

  .state {
    height: 35px;
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    >span {
      padding: 2px 10px;
      color: #ffffff;

      &:nth-of-type(1) {
        background-color: #cd4754;
      }

      &:nth-of-type(2) {
        background-color: #5dae72;
      }

      &:nth-of-type(3) {
        background-color: #e59b37;
      }

      &:nth-of-type(4) {
        background-color: #555555;
      }
    }

    >i {
      color: #7a7a7a;
      margin-right: 50px;
    }
  }

  .roundList {
    width: 100%;
    height: calc(100% - 35px - 50px);
    overflow-y: auto;
    padding: 0 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .noData {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .onData_box {
        >span {
          color: #7a7a7a;

          &:first-child {
            font-size: 32px;
          }

          &:last-child {
            font-size: 18px;
          }
        }
      }
    }

    .roundList_item {
      position: relative;
      width: 100%;
      margin-top: 20px;

      &:first-child {
        margin: 0;
      }

      .wheel_title {
        display: inline-block;
        font-size: 16px;
        margin-bottom: 5px;
      }

      .employee {
        position: relative;
        width: 100%;
        display: flex;
        flex-wrap: nowrap;
        overflow-x: auto;

        .employee_item,
        .employee_add {
          flex-shrink: 0;
          width: 80px;
          height: 110px;
          position: relative;
          margin: 0 10px 5px 0;
          border-radius: 5px;
          padding: 7px;
          user-select: none;
          cursor: pointer;
          float: left;
          box-sizing: border-box;
          background-color: #000000;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          &:last-child {
            margin: 0;
          }

          .popups {
            position: absolute;
            width: 100%;
            padding: 10px 5px;
            box-sizing: border-box;
            background-color: #fff;
            left: 0;
            top: 110px;
            border-radius: 4px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.62), 0 0 6px rgba(0, 0, 0, 0.24);
            z-index: 999;

            &::before {
              display: block;
              content: "";
              position: absolute;
              top: -7.5px;
              right: 7px;
              width: 15px;
              height: 15px;
              background-color: #fff;
              transform: rotate(45deg);
            }

            .popups_item {
              line-height: 45px;
              text-align: center;
              border-bottom: 1px solid #e3e3e3;
              cursor: pointer;
              user-select: none;

              &:last-child {
                border: 0;
              }
            }
          }

          >span {
            color: #fff;
            width: 100%;
            white-space: nowrap;
            /* 防止文本换行 */
            overflow: hidden;
            /* 文本溢出容器时隐藏 */
            text-overflow: ellipsis;
            /* 使用省略号表示被隐藏的文本 */

            &:nth-child(1) {
              font-size: 22px;
              font-weight: bold;
            }

            &:nth-child(2) {
              margin: 0 0 5px 0;
            }

            &:nth-child(3) {
              font-size: 12px;
            }
          }

          .employee_top {
            width: 100%;
            display: flex;
            align-items: flex-end;
            justify-content: space-between;

            >span.head {
              width: 25px;
              height: 25px;
              border-radius: 50%;
            }

            >span.icon {
              display: flex;
              align-items: center;
              color: #fff;

              >span {
                font-size: 12px;
                white-space: nowrap;
              }
            }
          }
        }

        .employee_add {
          position: relative;
          z-index: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #d7d7d7;

          >span {
            display: flex;
            justify-content: center;
            font-size: 30px !important;
          }
        }
      }
    }
  }

  .box_show {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999999;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.4);

    .screeningStaff {
      width: 600px;
      padding: 0 20px;
      box-sizing: border-box;
      border-radius: 5px;
      background-color: #ffffff;

      .header {
        height: 45px;
        line-height: 45px;
        font-size: 18px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        user-select: none;
      }

      .screenItem {
        height: 300px;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        align-content: flex-start;

        >div {
          display: flex;
          flex-direction: column;
          margin-bottom: 15px;

          >span {
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 15px;
          }

          >div {
            display: flex;
            flex-wrap: wrap;

            >div {
              display: flex;
              align-items: center;
              margin-bottom: 8px;
              user-select: none;
              cursor: pointer;

              i {
                font-size: 16px;

                &:first-child {
                  width: 25px;
                  height: 25px;
                  border-radius: 50%;
                  border: 1px solid #a7a7a7;
                  box-sizing: border-box;
                  margin-right: 10px;

                  &.active {
                    background-color: #838383;
                  }
                }

                &:last-child {
                  width: 145px;
                  font-size: 16px;
                  align-items: center;
                  white-space: nowrap;
                  overflow: hidden; //文本超出隐藏
                  text-overflow: ellipsis; //文本超出省略号替代
                }
              }
            }
          }
        }

        >span {
          width: 170px;
          height: 40px;
          margin: 10px 0 0 15px;
          display: flex;
          user-select: none;
          cursor: pointer;
          align-items: center;
          justify-content: space-between;
        }
      }

      .confirmAddition {
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;

        >span {
          width: 100px;
          line-height: 35px;
          font-size: 16px;
          text-align: center;
          margin: 0 10px;
          border-radius: 5px;
          background-color: #7a7a7a;
          color: #ffffff;
          cursor: pointer;
          user-select: none;

          &.active {
            background-color: #1e90ff;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/paperless/components/employeeRotation/index.vue